// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-contact-form {
  width: 100%;
  height: 100%;
  background-color: #fafafa;
}

.form-title {
  display: flex;
  justify-content: center;
}

.form-wrapper {
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 25px;
}

.form-group {
  display: flex;
  justify-content: space-between;
}

.to-field {
  display: block;
  height: 70px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding-left: 2px;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.to-field .newContactRecipient {
  margin: 1.25rem 0 0 1rem;
  padding: 4px 7px;
  border-radius: 12px;
  margin: 2px 3px;
  background-color: #12A7E6;
  color: white;
  font-size: 1rem;
  line-height: 1rem;
  white-space: break-spaces;
  display: inline-block;
}

.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 20px;
}

.full-width {
  width: 100%;
}

.half-width {
  width: 50%;
  margin: 0.5rem;
}

.button-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.submit-button {
  margin-left: 15px;
  border-radius: 22px;
  width: 100px;
}

.error-message {
  color: red;
  font-size: 0.8rem;
  margin-top: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/new-contact/new-contact.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;AACJ;;AAEA;EACI,cAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AACI;EACI,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;AACR;;AAGA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,UAAA;EACA,cAAA;AAAJ;;AAGA;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,mBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,UAAA;EACA,iBAAA;EACA,kBAAA;AAAJ","sourcesContent":[".new-contact-form {\n    width: 100%;\n    height: 100%;\n    background-color: #fafafa;\n}\n\n.form-title {\n    display: flex;\n    justify-content: center;\n}\n\n.form-wrapper {\n    padding-left: 25px;\n    padding-right: 25px;\n    padding-top: 25px;\n}\n\n.form-group {\n    display: flex;\n    justify-content: space-between;\n}\n\n.to-field {\n    display: block;\n    height: 70px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    background-color: white;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n    padding-left: 2px;\n    margin-top: 2rem;\n    margin-bottom: 1rem;\n\n    .newContactRecipient {\n        margin: 1.25rem 0 0 1rem;\n        padding: 4px 7px;\n        border-radius: 12px;\n        margin: 2px 3px;\n        background-color: #12A7E6;\n        color: white;\n        font-size: 1.0rem;\n        line-height: 1rem;\n        white-space: break-spaces;\n        display: inline-block;\n    }\n}\n\n.close-icon {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    cursor: pointer;\n    font-size: 20px;\n}\n\n.full-width {\n    width: 100%;\n}\n\n.half-width {\n    width: 50%;\n    margin: 0.5rem;\n}\n\n.button-container {\n    display: flex;\n    justify-content: center;\n    margin-top: 1rem;\n}\n\n.submit-button {\n    margin-left: 15px;\n    border-radius: 22px;\n    width: 100px;\n}\n\n.error-message {\n    color: red;\n    font-size: 0.8rem;\n    margin-top: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
